module.exports = __webpack_public_path__ + "static/img/AiImage-Item.d0c12e1.png";


//////////////////
// WEBPACK FOOTER
// ./src/components/AiImage/AiImage-Item.png
// module id = 304
// module chunks = 0